var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherReset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 6,
    fill: "#757575",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8521 7.85345C13.0473 7.65813 13.0472 7.34155 12.8519 7.14634C12.6565 6.95114 12.34 6.95123 12.1448 7.14655L9.99949 9.29307L7.85345 7.1483C7.65813 6.95309 7.34155 6.95318 7.14634 7.1485C6.95114 7.34382 6.95123 7.66041 7.14655 7.85561L9.29259 10.0004L7.14769 12.1466C6.95248 12.3419 6.95257 12.6585 7.14789 12.8537C7.34321 13.0489 7.6598 13.0488 7.855 12.8534L9.99991 10.7073L12.1466 12.8527C12.3419 13.0479 12.6585 13.0478 12.8537 12.8525C13.0489 12.6571 13.0488 12.3406 12.8535 12.1454L10.7068 9.99997L12.8521 7.85345Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherReset);
export default ForwardRef;